
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})

export class RoomReservationService {

    apiServer = environment.apiHost + environment.apiPort;
    constructor( 
      public http: HttpClient 
    ) { }

    loadByDateInterval(subscriber: string, hotelId: number , dateFrom: string, dateTo: string) {
      return this.http.get(`${this.apiServer}/api/kip/RoomReservation/LoadFutureRes/${subscriber}/${hotelId}/${dateFrom}/${dateTo}`)
    }
}
